import dynamic from "next/dynamic";
const SelectableTagsGridComponent = dynamic(()=>import("./selectable-tags-grid-component"));
import SelectableTagsGridConfig from "./selectable-tags-grid-config";
import SelectableTagsGridAdvancedConfig from "./selectable-tags-grid-advanced-config";
export default {
    SelectableTagsGridComponent,
    SelectableTagsGridConfig,
    SelectableTagsGridAdvancedConfig
};
